export default __webpack_public_path__ + "static/media/logo_no_text.47901580.svg";